var map = {
	"./floor2/map.png": "9cb1",
	"./floor2/map.svg": "2ace",
	"./floor2/rooms/10.svg": "fdb9",
	"./floor2/rooms/11.svg": "e4e1",
	"./floor2/rooms/12.svg": "6d09",
	"./floor2/rooms/13.svg": "57d8",
	"./floor2/rooms/14.svg": "5ed9",
	"./floor2/rooms/18.svg": "1381",
	"./floor2/rooms/20.svg": "411d",
	"./floor2/rooms/21.svg": "7a52",
	"./floor2/rooms/25.svg": "4dc9",
	"./floor2/rooms/27.svg": "0e8a",
	"./floor2/rooms/28.svg": "5cfe",
	"./floor2/rooms/33.svg": "9c9a",
	"./floor2/rooms/39.svg": "ace5",
	"./floor2/rooms/41.svg": "fb4f",
	"./floor2/rooms/43.svg": "8b20",
	"./floor2/rooms/45.svg": "6c65",
	"./floor2/rooms/48.svg": "1d60",
	"./floor2/rooms/5.svg": "c2e0",
	"./floor2/rooms/50.svg": "c0da",
	"./floor2/rooms/55.svg": "9abf",
	"./floor2/rooms/55b.svg": "27d3",
	"./floor2/rooms/59.svg": "e3bd",
	"./floor2/rooms/6.svg": "2958",
	"./floor2/rooms/61.svg": "855e",
	"./floor2/rooms/64.svg": "bd24",
	"./floor2/rooms/8.svg": "5565",
	"./floor2/rooms/9.svg": "1aea",
	"./floor2/rooms/AlfredNobel.jpg": "7e08",
	"./floor2/rooms/Antoinelavoisier.jpg": "3273",
	"./floor2/rooms/Democritus.jpg": "b477",
	"./floor2/rooms/ErnestRutherford.jpg": "b600",
	"./floor2/rooms/IgnacyLukasiewicz.jpg": "a121",
	"./floor2/rooms/NielsBohr.jpg": "ad0a",
	"./floor2/rooms/OttoHahn.jpg": "f127",
	"./floor2/rooms/PaulingLinus.jpg": "121f",
	"./floor2/rooms/RamsayWilliam.jpg": "b1b9",
	"./floor2/rooms/SklodowskaCurieMaria.jpg": "bf83",
	"./floor2/rooms/reception.svg": "9a0d",
	"./floor2/rooms/w1.svg": "e404",
	"./floor2/rooms/w10.svg": "5beb",
	"./floor2/rooms/w10b.jpg": "6ba6",
	"./floor2/rooms/w11.svg": "cb31",
	"./floor2/rooms/w11b.jpg": "ce0e",
	"./floor2/rooms/w12.svg": "8180",
	"./floor2/rooms/w12b.jpg": "d057",
	"./floor2/rooms/w13.svg": "4fe9",
	"./floor2/rooms/w13b.jpg": "f37b",
	"./floor2/rooms/w14.svg": "c681",
	"./floor2/rooms/w14b.jpg": "c883",
	"./floor2/rooms/w15.svg": "ac01",
	"./floor2/rooms/w15b.jpg": "bc87",
	"./floor2/rooms/w16.svg": "5438",
	"./floor2/rooms/w16b.jpg": "61b6",
	"./floor2/rooms/w17.svg": "6a6f",
	"./floor2/rooms/w17b.jpg": "99bf",
	"./floor2/rooms/w18.svg": "1343",
	"./floor2/rooms/w18b.jpg": "9a9f",
	"./floor2/rooms/w19.svg": "1a36",
	"./floor2/rooms/w19b.jpg": "a6b6",
	"./floor2/rooms/w1b.jpg": "001b",
	"./floor2/rooms/w2.svg": "0419",
	"./floor2/rooms/w20.svg": "4ba8",
	"./floor2/rooms/w20b.jpg": "b133",
	"./floor2/rooms/w21.svg": "4122",
	"./floor2/rooms/w21b.jpg": "942c",
	"./floor2/rooms/w22.svg": "cd98",
	"./floor2/rooms/w22b.jpg": "1424",
	"./floor2/rooms/w23.svg": "0f75",
	"./floor2/rooms/w23b.jpg": "a1ec",
	"./floor2/rooms/w24.svg": "503e",
	"./floor2/rooms/w24b.jpg": "5304",
	"./floor2/rooms/w25.svg": "20f3",
	"./floor2/rooms/w25b.jpg": "3359",
	"./floor2/rooms/w26.svg": "effb",
	"./floor2/rooms/w26b.jpg": "e614",
	"./floor2/rooms/w27.svg": "bb33",
	"./floor2/rooms/w27b.jpg": "3908",
	"./floor2/rooms/w28.svg": "fd52",
	"./floor2/rooms/w28b.jpg": "785e",
	"./floor2/rooms/w29.svg": "ae0e",
	"./floor2/rooms/w29b.jpg": "e1a8",
	"./floor2/rooms/w2b.jpg": "7ad5",
	"./floor2/rooms/w3.svg": "683b",
	"./floor2/rooms/w30.svg": "b749",
	"./floor2/rooms/w30b.jpg": "11ab",
	"./floor2/rooms/w31.svg": "a12e",
	"./floor2/rooms/w31b.jpg": "386b",
	"./floor2/rooms/w32.svg": "2e7f",
	"./floor2/rooms/w32b.jpg": "cc99",
	"./floor2/rooms/w33.svg": "6042",
	"./floor2/rooms/w33b.jpg": "cbe8",
	"./floor2/rooms/w34.svg": "3a08",
	"./floor2/rooms/w34b.jpg": "9498",
	"./floor2/rooms/w35.svg": "6e94",
	"./floor2/rooms/w35b.jpg": "358e",
	"./floor2/rooms/w36.svg": "88c3",
	"./floor2/rooms/w36b.jpg": "7d6c",
	"./floor2/rooms/w37.svg": "adb9",
	"./floor2/rooms/w37b.jpg": "9942",
	"./floor2/rooms/w38.svg": "e2e7",
	"./floor2/rooms/w38b.jpg": "1a7c",
	"./floor2/rooms/w39.svg": "f00d",
	"./floor2/rooms/w39b.jpg": "a163",
	"./floor2/rooms/w3b.jpg": "19bc",
	"./floor2/rooms/w4.svg": "5acb",
	"./floor2/rooms/w40.svg": "f35b",
	"./floor2/rooms/w40b.jpg": "704f",
	"./floor2/rooms/w41.svg": "0bfe",
	"./floor2/rooms/w41b.jpg": "9e92",
	"./floor2/rooms/w4b.jpg": "9571",
	"./floor2/rooms/w5.svg": "15b7",
	"./floor2/rooms/w5b.jpg": "fe20",
	"./floor2/rooms/w6.svg": "0fa3",
	"./floor2/rooms/w6b.jpg": "ca53",
	"./floor2/rooms/w7.svg": "d3d7",
	"./floor2/rooms/w7b.jpg": "29e8",
	"./floor2/rooms/w8.svg": "1a92",
	"./floor2/rooms/w8b.jpg": "8ceb",
	"./floor2/rooms/w9.svg": "cc13",
	"./floor2/rooms/w9b.jpg": "1594",
	"./floor3/map.png": "6343",
	"./floor3/map.svg": "9f69",
	"./floor3/rooms/18.svg": "d7e9",
	"./floor3/rooms/19.svg": "a9ab",
	"./floor3/rooms/20.svg": "e5a1",
	"./floor3/rooms/24.svg": "66ea",
	"./floor3/rooms/25.svg": "acbc",
	"./floor3/rooms/30.svg": "6008",
	"./floor3/rooms/32.svg": "e00d",
	"./floor3/rooms/36.svg": "a0ed",
	"./floor3/rooms/37.svg": "af88",
	"./floor3/rooms/38.svg": "38c6",
	"./floor3/rooms/44.svg": "016f",
	"./floor3/rooms/47.svg": "c8b2",
	"./floor3/rooms/48.svg": "a0c7",
	"./floor3/rooms/5.svg": "2529",
	"./floor3/rooms/50.svg": "0f09",
	"./floor3/rooms/51.svg": "7413",
	"./floor3/rooms/52.svg": "81e0",
	"./floor3/rooms/53.svg": "67f4",
	"./floor3/rooms/54.svg": "2a59",
	"./floor3/rooms/7.svg": "3658",
	"./floor3/rooms/9.svg": "0121",
	"./floor3/rooms/AlbertEinstein.jpg": "d304",
	"./floor3/rooms/AvogadroAmedeo.jpg": "4973",
	"./floor3/rooms/DaltonJohn.jpg": "aba3",
	"./floor3/rooms/FrederickSanger.jpg": "a7d1",
	"./floor3/rooms/LouisPasteur.jpg": "15d6",
	"./floor3/rooms/MendeleevDimitri.jpg": "9e8b",
	"./floor3/rooms/MichaelFaraday.jpg": "e00b",
	"./floor3/rooms/RobertBoyle.jpg": "b5a7",
	"./floor3/rooms/w42.svg": "df72",
	"./floor3/rooms/w42b.jpg": "b8b2",
	"./floor3/rooms/w43.svg": "0ec3",
	"./floor3/rooms/w43b.jpg": "1b0b",
	"./floor3/rooms/w44.svg": "3efc",
	"./floor3/rooms/w44b.jpg": "a4c0",
	"./floor3/rooms/w45.svg": "0707",
	"./floor3/rooms/w45b.jpg": "1e4b",
	"./floor3/rooms/w46.svg": "d5ba",
	"./floor3/rooms/w46b.jpg": "26db",
	"./floor3/rooms/w47.svg": "c7d5",
	"./floor3/rooms/w47b.jpg": "6c67",
	"./floor3/rooms/w48.svg": "382b",
	"./floor3/rooms/w48b.jpg": "2278",
	"./floor3/rooms/w49.svg": "4031",
	"./floor3/rooms/w49b.jpg": "d179",
	"./floor3/rooms/w50.svg": "8713",
	"./floor3/rooms/w50b.jpg": "f2fd",
	"./floor3/rooms/w51.svg": "558e",
	"./floor3/rooms/w51b.jpg": "e023",
	"./floor3/rooms/w52.svg": "8a8f",
	"./floor3/rooms/w52b.jpg": "bb05",
	"./floor3/rooms/w53.svg": "fb5a",
	"./floor3/rooms/w53b.jpg": "a409",
	"./floor3/rooms/w54.svg": "dc35",
	"./floor3/rooms/w54b.jpg": "1d3a",
	"./floor3/rooms/w55.svg": "0a2e",
	"./floor3/rooms/w55b.jpg": "4c92",
	"./floor3/rooms/w56.svg": "8372",
	"./floor3/rooms/w56b.jpg": "bee8",
	"./floor3/rooms/w57.svg": "df52",
	"./floor3/rooms/w57b.jpg": "1aaa",
	"./floor3/rooms/w58.svg": "731a",
	"./floor3/rooms/w58b.jpg": "27d3c",
	"./floor3/rooms/w59.svg": "ee55",
	"./floor3/rooms/w59b.jpg": "509c",
	"./floor3/rooms/w60.svg": "a636",
	"./floor3/rooms/w60b.jpg": "c17d",
	"./floor3/rooms/w61.svg": "6a21",
	"./floor3/rooms/w61b.jpg": "98ad",
	"./floor3/rooms/w62.svg": "dd69",
	"./floor3/rooms/w62b.jpg": "6027",
	"./floor3/rooms/w63.svg": "dddb",
	"./floor3/rooms/w63b.jpg": "04d9",
	"./floor3/rooms/w64.svg": "2c4b",
	"./floor3/rooms/w64b.jpg": "0796",
	"./floor3/rooms/w65.svg": "1995",
	"./floor3/rooms/w65b.jpg": "855ea",
	"./floor3/rooms/w66.svg": "b276",
	"./floor3/rooms/w66b.jpg": "c057",
	"./floor3/rooms/w67.svg": "a849",
	"./floor3/rooms/w67b.jpg": "bd63",
	"./floor3/rooms/w68.svg": "788d",
	"./floor3/rooms/w68b.jpg": "8df6",
	"./floor3/rooms/w69.svg": "12a7",
	"./floor3/rooms/w69b.jpg": "f795",
	"./floor3/rooms/w70.svg": "e868",
	"./floor3/rooms/w70b.jpg": "6d98",
	"./floor3/rooms/w71.svg": "b6a5",
	"./floor3/rooms/w71b.jpg": "05c4",
	"./floor3/rooms/w72.svg": "a4e8",
	"./floor3/rooms/w72b.jpg": "ea51",
	"./floor3/rooms/w73.svg": "99fa",
	"./floor3/rooms/w73b.jpg": "0a2a",
	"./floor3/rooms/w74.svg": "df13",
	"./floor3/rooms/w74b.jpg": "d7a9",
	"./floor3/rooms/w75.svg": "43f8",
	"./floor3/rooms/w75b.jpg": "3137",
	"./floor3/rooms/w76.svg": "3fca",
	"./floor3/rooms/w76b.jpg": "59db",
	"./floor3/rooms/w77.svg": "b54f",
	"./floor3/rooms/w77b.jpg": "e314",
	"./floor3/rooms/w78.svg": "7c69",
	"./floor3/rooms/w78b.jpg": "12f6",
	"./floor3/rooms/w79.svg": "74f5",
	"./floor3/rooms/w79b.jpg": "1f1c",
	"./floor3/rooms/w80.svg": "72d4",
	"./floor3/rooms/w80b.jpg": "8e32",
	"./monopolis/map.svg": "23fe",
	"./monopolis/rooms/arteria.jpg": "fe13",
	"./monopolis/rooms/monocafe.jpg": "7505",
	"./monopolis/rooms/piekarnia.jpg": "d58d",
	"./monopolis/rooms/restaurants.svg": "8c1b",
	"./monopolis/rooms/sendai.jpg": "8a67",
	"./monopolis/rooms/trattoria.jpg": "7e63",
	"./pin.svg": "18e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f046";